import * as React from "react";

const PlusIconSVG = ({
    fill = "#5B21B6"
}) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40">
        <path fill={fill} d="M19 21h-6v-2h6v-6h2v6h6v2h-6v6h-2z" />
    </svg>
);

export default PlusIconSVG;
